import { render, staticRenderFns } from "./TermoAceite.vue?vue&type=template&id=72a15280&scoped=true"
import script from "./TermoAceite.vue?vue&type=script&lang=js"
export * from "./TermoAceite.vue?vue&type=script&lang=js"
import style0 from "./TermoAceite.vue?vue&type=style&index=0&id=72a15280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a15280",
  null
  
)

export default component.exports